module.exports = __webpack_public_path__ + "img/mcgl_xsbj_02.bae6c1a1.png";